import { FC } from "react";

import TableCriteriaVerification from "../../components/table/criteria/TableCriteriaVerification";

import styles from "./criteria.module.scss";

const Criteria: FC = () => {
  return (
    <div className={styles.criteria}>
      <TableCriteriaVerification />
    </div>
  );
};

export default Criteria;
